export function getValue(key) {
  if (window && window.localStorage) {
    return window.localStorage.getItem(key);
  }
  return null;
}

export function setValue(key, value) {
  if (window && window.localStorage) {
    window.localStorage.setItem(key, value);
  } else {
    console.warn('Session storage is not available in this environment.');
  }
}

export function removeValue(key) {
  if (window && window.localStorage) {
    window.localStorage.removeItem(key);
  } else {
    console.warn('Session storage is not available in this environment.');
  }
}
